/** «Подключенные функции» + «Отзывы» strings. Kept in their own file so the
 *  feature can grow without everyone editing the 5k-line dictionaries.ts. */
export const featuresRu: Record<string, string> = {
  'features.heading': 'Подключение функций',
  'features.enableFor': 'Включить {{name}} для этого филиала',
  'features.disableFor': 'Выключить {{name}} для этого филиала',
  'features.disableConfirm': 'Выключить {{name}}?',
  'features.disable': 'Выключить',
  'features.askAdmin': 'Включить функцию может администратор филиала.',
  'features.needsMicrophone': 'Чтобы включить анализ речи, подключите микрофон в системе.',
  'features.goToEquipment': 'Перейти к оборудованию',
  'features.status.off': 'Выключено',
  'features.status.needsMic': 'Нужен микрофон',

  'features.speech.name': 'Анализ речи',
  'features.speech.pitch': 'Анализ разговоров на кассе: как здороваются, предлагают ли дополнительно, где теряются гости.',
  'features.speech.placeholder': 'Микрофон подключён. Разговоры разбираются автоматически — смотрите их в Статистике, на вкладке «Речь». Отдельных настроек пока нет.',
  'features.speech.settingsDescription': 'Разбор разговоров на кассе',

  'features.checklists.name': 'Чек-листы',
  'features.checklists.pitch': 'Ежедневные задачи смены с фотоотчётом: открытие, закрытие, санитария.',

  'features.receipts.name': 'Чеки',
  'features.receipts.pitch': 'Чеки из кассы (ОФД): сколько чеков, средний чек, что продаётся и кто пробил — рядом с камерами и разговорами.',
  'features.receipts.settingsDescription': 'Подключение к ОФД и кассы точек',

  'features.sales_plan.name': 'План продаж',
  'features.sales_plan.pitch': 'Что предлагать гостю прямо сейчас и цели дня — крупно на дашборде смены, у кассы.',
  'features.sales_plan.settingsDescription': 'Что предлагаем по времени дня, напоминания и цели на день',

  'features.visits.name': 'Визиты',
  'features.visits.pitch': 'Проверки филиала по чек-листу качества с оценкой и фото.',

  'features.reviews.name': 'Отзывы',
  'features.reviews.pitch': 'Отзывы с Яндекс Карт и 2ГИС в одном месте плюс свой QR-код, чтобы собирать отзывы прямо в зале.',
  'features.reviews.settingsDescription': 'Карты, своя форма отзыва и QR-код',
  // Две строки вместо одной в «Подключенных функциях» (Алексей 17.09, AI37):
  // карты и свой QR — разные вещи, и включены они бывают порознь.
  'features.reviewsMaps.name': 'Отзывы с карт',
  'features.reviewsQr.name': 'Отзывы по QR',
  'features.reviewsQr.noneYet': 'Ещё нет отзывов',

  'features.wifi.name': 'Гостевой Wi-Fi',
  'features.wifi.pitch': 'Статистика по устройствам в сети филиала: сколько гостей, кто возвращается, как долго сидят.',
  'features.status.needsRouter': 'Нужен роутер',

  'sidebar.reviews': 'Отзывы',
  'sidebar.speech': 'Анализ речи',
  'sidebar.checklistsLive': 'Чек-листы',
  'sidebar.group.functions': 'Настройка функций',
  'sidebar.functionSettings': 'Функции',
  'sidebar.branchIntegrations': 'Интеграции',
  'sidebar.connectedFeatures': 'Подключённые функции',
  'sidebar.group.branch': 'Филиал',

  'general.address': 'Адрес',
  'general.addressPlaceholder': 'Укажите адрес филиала',

  // Сеть филиала и её плагин (Алексей 07.10, #1278–#1279)
  'general.brand': 'Сеть',
  'general.brand.none': 'Не указана',
  'general.websiteUrl': 'Страница филиала на сайте',
  'general.websiteUrlPlaceholder': 'Ссылка на страницу филиала на сайте сети',
  'hours.match': 'Совпадает с {{name}}',
  'hours.link': 'Привязать {{name}}',
  'hours.staffArrival': 'Сотрудники должны приходить за {{minutes}} мин',
  'features.staff_arrival.name': 'Открытие смены',
  'features.staff_arrival.pitch': 'Видим, во сколько первый сотрудник появился за баром, и напоминаем, если к назначенному времени никого нет.',
  'features.status.needsStaffPolygon': 'Нужны полигоны бара или кассы',
  'hours.nom.site': 'сайт',
  'hours.nom.yandex': 'Яндекс Карты',
  'hours.nom.2gis': '2ГИС',
  'hours.mismatch': 'Расходится с {{name}}',
  'hours.unreadable': 'Не удалось сверить с {{name}}',
  'hours.recheck': 'Проверить снова',
  'hours.sync.off': 'Не синхронизировать часы с сайтом и картами',
  'hours.sync.offChip': 'синк отключён',
  'hours.sync.notePlaceholder': 'Почему (необязательно): например, на сайте 10:00, открываемся в 08:00',
  'hours.src.site': 'сайтом',
  'hours.src.yandex': 'Яндекс Картами',
  'hours.src.2gis': '2ГИС',
  'brand.integration': 'Интеграция с сетью',
  'brand.hours.title': 'Часы работы на сайте сети',
  'brand.hours.noWebsite': 'Укажите страницу филиала на сайте — сверим часы работы с ней.',
  'brand.hours.reading': 'Читаем страницу филиала…',
  'brand.hours.match': 'Совпадают с графиком работы филиала',
  'brand.hours.mismatch': 'Расходятся с графиком работы филиала',
  'brand.hours.oursMissing': 'У филиала график работы не задан — можно взять с сайта',
  'brand.hours.unreadable': 'Не удалось прочитать часы работы на сайте',
  'brand.hours.onSite': 'На сайте',
  'brand.hours.ours': 'У нас',
  'brand.hours.differs': 'Разные дни',
  'brand.hours.takeFromSite': 'Взять с сайта',
  'brand.hours.recheck': 'Проверить снова',
  'brand.qrStyle': 'QR-коды и форма отзыва — в фирменном стиле {{name}}',
  'brand.reviews.networkStyle': 'стиль сети',
};

export const featuresEn: Record<string, string> = {
  'features.heading': 'Enabling features',
  'features.enableFor': 'Enable {{name}} for this branch',
  'features.disableFor': 'Disable {{name}} for this branch',
  'features.disableConfirm': 'Disable {{name}}?',
  'features.disable': 'Disable',
  'features.askAdmin': 'Only a branch admin can switch this on.',
  'features.needsMicrophone': 'Connect a microphone to enable speech analysis.',
  'features.goToEquipment': 'Go to equipment',
  'features.status.off': 'Off',
  'features.status.needsMic': 'Needs a microphone',

  'features.speech.name': 'Speech analysis',
  'features.speech.pitch': 'Counter conversations analysed: greetings, upsells, where guests are lost.',
  'features.speech.placeholder': 'Microphone connected. Conversations are analysed automatically — see them in Statistics → Speech. No separate settings yet.',
  'features.speech.settingsDescription': 'Counter conversation analysis',

  'features.checklists.name': 'Checklists',
  'features.checklists.pitch': 'Daily shift tasks with photo reports: opening, closing, hygiene.',

  'features.receipts.name': 'Receipts',
  'features.receipts.pitch': 'Till receipts from the fiscal data operator: count, average check, what sells and who rang it up.',
  'features.receipts.settingsDescription': 'Fiscal data operator connection and tills',

  'features.sales_plan.name': 'Sales plan',
  'features.sales_plan.pitch': 'What to offer guests right now and the day’s targets — big on the shift dashboard, at the till.',
  'features.sales_plan.settingsDescription': 'Offers by time of day, reminders and daily targets',

  'features.visits.name': 'Visits',
  'features.visits.pitch': 'Quality walkthroughs scored against a template, with photos.',

  'features.reviews.name': 'Reviews',
  'features.reviews.pitch': 'Yandex Maps and 2GIS reviews in one place, plus your own QR code to collect reviews on site.',
  'features.reviews.settingsDescription': 'Maps, your own review form and QR code',
  'features.reviewsMaps.name': 'Reviews from maps',
  'features.reviewsQr.name': 'Reviews via QR',
  'features.reviewsQr.noneYet': 'No reviews yet',

  'features.wifi.name': 'Guest Wi-Fi',
  'features.wifi.pitch': 'Who is on the branch network: how many guests, who returns, how long they stay.',
  'features.status.needsRouter': 'Needs a router',

  'sidebar.reviews': 'Reviews',
  'sidebar.speech': 'Speech analysis',
  'sidebar.checklistsLive': 'Checklists',
  'sidebar.group.functions': 'Feature setup',
  'sidebar.functionSettings': 'Features',
  'sidebar.branchIntegrations': 'Integrations',
  'sidebar.connectedFeatures': 'Connected features',
  'sidebar.group.branch': 'Branch',

  'general.address': 'Address',
  'general.addressPlaceholder': 'Add the branch address',

  'general.brand': 'Chain',
  'general.brand.none': 'Not set',
  'general.websiteUrl': 'Branch page on the website',
  'general.websiteUrlPlaceholder': 'Branch page URL on the chain website',
  'hours.match': 'Matches {{name}}',
  'hours.link': 'Link {{name}}',
  'hours.staffArrival': 'Staff should arrive {{minutes}} min before opening',
  'features.staff_arrival.name': 'Shift opening',
  'features.staff_arrival.pitch': 'See when the first team member showed up behind the bar and get a nudge when nobody is there by the set time.',
  'features.status.needsStaffPolygon': 'Needs bar or cashier polygons',
  'hours.nom.site': 'website',
  'hours.nom.yandex': 'Yandex Maps',
  'hours.nom.2gis': '2GIS',
  'hours.mismatch': 'Differs from {{name}}',
  'hours.unreadable': 'Could not check against {{name}}',
  'hours.recheck': 'Check again',
  'hours.sync.off': 'Do not sync hours with the website and maps',
  'hours.sync.offChip': 'sync off',
  'hours.sync.notePlaceholder': 'Reason (optional): e.g. website says 10:00, we open at 08:00',
  'hours.src.site': 'the website',
  'hours.src.yandex': 'Yandex Maps',
  'hours.src.2gis': '2GIS',
  'brand.integration': 'Chain integration',
  'brand.hours.title': 'Working hours on the chain website',
  'brand.hours.noWebsite': 'Add the branch page URL — we will compare working hours with it.',
  'brand.hours.reading': 'Reading the branch page…',
  'brand.hours.match': 'Match the branch schedule',
  'brand.hours.mismatch': 'Differ from the branch schedule',
  'brand.hours.oursMissing': 'The branch has no schedule yet — take it from the website',
  'brand.hours.unreadable': 'Could not read working hours from the website',
  'brand.hours.onSite': 'On the website',
  'brand.hours.ours': 'Ours',
  'brand.hours.differs': 'Days that differ',
  'brand.hours.takeFromSite': 'Take from website',
  'brand.hours.recheck': 'Check again',
  'brand.qrStyle': 'QR codes and the review form use the {{name}} brand style',
  'brand.reviews.networkStyle': 'chain style',
};
